import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getWorkspaceDirectories,
  setWorkspaceDirectories,
  menuPageSize as pageSize,
} from "./actions";
import { getWorkspaceMenuState } from "../selectors";
import { MenuTree } from "features/System/TreeMenu";
import { toggleFavouriteSite } from "features/Workspace/WorkspaceDashboard/actions";

const WorkspaceMenu = () => {
  const treeData = useSelector(getWorkspaceMenuState);

  const dispatch = useDispatch();

  useEffect(() => {
    getTreeData();
  }, []);

  const getTreeData = function (rootDirectoryId, pageNumber = 1) {
    if (
      treeData.loadingIds.some((x) => x.id == rootDirectoryId) ||
      (!rootDirectoryId && pageNumber == 1 && !!treeData.data.totalResults)
    ) {
      return;
    }
    dispatch(
      getWorkspaceDirectories(rootDirectoryId, { pageSize, pageNumber })
    ).then((x) =>
      dispatch(setWorkspaceDirectories(x, rootDirectoryId, pageNumber))
    );
  };

  return (
    <React.Fragment>
      <MenuTree
        sites={treeData.data.results}
        onNodeExpanded={(x) => {
          // null files means this node has never been fetched, whatever its folders say
          const foldersMissing = !!x.directoriesCount && !x.directories.length;
          if (x.files == null || foldersMissing) {
            getTreeData(x.id);
          }
        }}
        totalNodes={treeData.data.totalResults}
        onLoadMore={() => getTreeData(null, treeData.pagesLoaded + 1)}
        loadingIds={treeData.loadingIds}
        className="workspace-item"
        showFiles
        rootAsHeader
        // sites are ordered favourites-first, so the whole root page is refetched rather than
        // the one node being patched in place
        onToggleFavourite={(node) =>
          dispatch(
            toggleFavouriteSite({
              siteId: node.siteId,
              isFavourite: !node.favourite,
            })
          ).then(() =>
            dispatch(
              getWorkspaceDirectories(null, { pageSize, pageNumber: 1 }, true)
            ).then((x) => dispatch(setWorkspaceDirectories(x, null, 1)))
          )
        }
      />
    </React.Fragment>
  );
};

export default WorkspaceMenu;
